import styled from 'styled-components';
import { CellData, GeneratedColumn, RequiredGeneratorParams } from '../common';
import { TypographyClean } from '../../../utils/styles';

// Addresses can outgrow the column, so they truncate on one line and show in full on hover
const Email = styled(TypographyClean)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export type UserEmailAccessorType = {
  email: string;
};

const UserEmailCellDecorator: React.FC<{
  cellData: UserEmailAccessorType;
}> = ({ cellData }) => {
  if (!cellData) {
    return null;
  }

  return <Email title={cellData.email}>{cellData.email}</Email>;
};

function getUserEmailColumn<T extends object = UserEmailAccessorType>({
  columnId,
  accessor,
}: RequiredGeneratorParams<T, UserEmailAccessorType>): GeneratedColumn<T> {
  return {
    id: columnId,
    accessor,
    Cell: (data: CellData<T, UserEmailAccessorType>) => <UserEmailCellDecorator cellData={data?.cell?.value} />,
  };
}

export default getUserEmailColumn;
